define('components/decorators/volglijst',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator',
    '../util/tool-menu',
    '../handlers/analytics',
    '../util/apiendpoints'

],function( $, reload, decorator, toolMenu, analytics ){
    var FORM_ERROR_HEADER = 'form-errors';

    $.extend(companyInfo.decorators,{
        'volglijst': function(){
            var component = $(this);
            var accordions = component.find(".accordion-content");

            var reloadType = component.data('reload-type');
            var reloadIds;
            var request;


            accordions.on('submit','form',handleSubmit);
            accordions.on('click','button',handleSubmit);
            accordions.on('click','a[name]',handleSubmit);

            function renderContent( response ){
                component.html( response );
                setTimeout(function(){ // give HTML some time to render.
                    decorator.run();
                },200);
            }

            function handlePostResponse(response, status, request){
                component.find('input').val('');
                component.find('select').val('').change();

                if ( !request.getResponseHeader(FORM_ERROR_HEADER) ) {
                    setLoading();
                    var sections = reload.getSections(reloadType, reloadIds);
                    reload.clearCache();
                    reload.replaceContent(response,sections);
                    unsetLoading();
                } else {
                    //only render content when response has error header
                    renderContent(response);
                    unsetLoading();
                }
            }

            function handleSubmit(e){
                e.preventDefault();
                if ( request || e.type === "click" && $(this).data('handler') ) {
                    return;
                }

                var form = e.type === "submit" ? $(this) : $(this).closest('form');
                var button = e.type === "click" ? this : undefined;

                reloadIds = [];

                var props = generateProperties(form, button);
                var textInputValue = props.data[0].value;

                if (textInputValue) {
                    setLoading();
                }

                if(props){
                  reloadIds.push('news-panel');

                  request = $.ajax({
                      url: props.action,
                      method: props.method,
                      data: props.data,
                      cache: false
                  }).done(handlePostResponse).fail(function(){
                      log("Failed submit request", arguments);
                  });
                }

            }

            function generateProperties(form, button) {
              var method = form.attr('method');
              var action = form.attr('action');
              var data = form.serializeArray();

              if (button) {
                if(button.value){
                    data.push({'name': button.name, 'value': button.value});
                }else{
                    data.push({'name': button.name, 'value': $(button).attr('value')});
                }
              }

              if (form.data('volg-type') === 'organisations' || button && button.name === "delete-favorite") {
                reloadIds.push('volglijst-queries');
                reloadIds.push('volglijst-organisations-title');

                if (!button) {
                  data.push({'name': 'add-organisation', 'value': '+'});
                }
              } else if (form.data('volg-type') === 'sectors' || button && button.name === "delete-sector") {
                reloadIds.push('volglijst-sectors');
                reloadIds.push('volglijst-sectors-title');
                reloadIds.push('volglijst-sectors-select');

                if (!button) {
                  data.push({'name': 'add-sector', 'value': '+'});
                }
              } else if (form.data('volg-type') === 'queries' || button && button.name === "delete-query") {
                reloadIds.push('volglijst-news');
                reloadIds.push('saved-queries');
                reloadIds.push('volglijst-news-title');
                if (!button) {
                  data.push({'name': 'add-query', 'value': '+'});
                }
              } else if (form.data('volg-type') === 'queries' || button && button.name === "delete-query-ajax") {

                var $button = $(button);
                var id = $button.attr("value");
                var translations = JSON.parse($button.data("translations"));
                var panelContent = $button.closest(".panel-content");

                //set analytics, if found
                var dataAnalyticsParams = $button.data("analytics-params");
                if(dataAnalyticsParams){
                  analytics(dataAnalyticsParams);
                }

                alertMessage.settings({
                  autoClose: 3000
                });

                queriesService.deleteQuery(id)
                .done(function(response){
                  alertMessage.show(translations["delete.success"], panelContent);
                  var line = $button.closest("tr");
                  line.remove();
                })
                .fail(function(response){
                  alertMessage.settings({"type": "error"});
                  var statusCode = response.status;
                  alertMessage.show(translations["delete.fail"], panelContent);
                })
                .always(function(){
                  unsetLoading();
                });

                return;
              }

              return {method: method, action: action, data: data};
            }

            function setLoading(){
                component.addClass('loading');
            }

            function unsetLoading(){
                component.removeClass('loading');
                request = null;
            }
        }

    });


    function log( message, data ){
        console && console.log && console.log( message, data );
    }
});

